import { Route, Routes } from "react-router-dom";
import { HomeProvider } from "../contexts/contexHome";
import { LoginProvider } from "../contexts/contexLogin";
import { NTanqueProvider } from "../contexts/contextTanque";
import { Home } from "../pages/home";
import { Login } from "../pages/login";
import { NotFound } from "../pages/notFound";
import { MotoBombaJm } from "../pages/MotoBombas/motoBombaJM";
import { MotobombaProvider } from "../contexts/contexMotobomba";
import { AdminProvider } from "../contexts/contexAdmin";
import { PageAdmin } from "../pages/admin";
import { Unidades } from "../pages/home/Unidades";
import { Tanque } from "../pages/tanques/tanques";

export const RoutesMain = () => {
  return (
    <Routes>
      <Route element={<HomeProvider />}>
        <Route path="/" element={<Home />} />
        <Route path="/:unidade" element={<Unidades />} />

        <Route element={<NTanqueProvider />}>
          <Route path="/:unidade/tanques" element={<Tanque />} />
        </Route>

        <Route element={<MotobombaProvider />}>
          <Route path="/JallesMachado/Motobomba" element={<MotoBombaJm />} />
        </Route>
        <Route element={<AdminProvider />}>
          <Route path="/Admin" element={<PageAdmin />} />
        </Route>
      </Route>
      <Route element={<LoginProvider />}>
        <Route path="/Login" element={<Login />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
